import React from 'react'
import { Footer } from '../components/Footer'
import { Header } from '../components/Header'
import Head from 'next/head'
import HeadMeta from '../components/HeadMeta'
import { GlobalNav } from '../components/GlobalNav'

const OitanaviPage = () => {
  return (
    <div>
      <HeadMeta title="2024年住宅支援策 | 株式会社ベツダイ" description="2024年住宅支援策" />
      <noscript>
        &lt;style&gt;body{'{'}visibility:visible{'}'}&lt;/style&gt;
      </noscript>
      <div className="c-page-sub__base">
        <div className="c-page-sub__header">
          <Header />
        </div>
        <div className="c-page-sub__globalnav" data-sponly>
          <GlobalNav />
        </div>

        <div className="hojyokin2024">
          <div className="fv">
            <div className="fv_image"></div>
            <ul className="fv_navi">
              <li className="fv_naviItem color01">
                <a href="#block01" className="fv_naviLink">
                子育てエコホーム支援事業
                </a>
              </li>
              <li className="fv_naviItem color02">
                <a href="#block02" className="fv_naviLink">
住宅ローン減税
                </a>
              </li>
              <li className="fv_naviItem color03">
                <a href="#block03" className="fv_naviLink">
贈与税非課税枠
                </a>
              </li>
              <li className="fv_naviItem color04">
                <a href="#block04" className="fv_naviLink">
【フラット35】
                </a>
              </li>
            </ul>
          </div>
          <div className="block block01" id='block01'>
            <img className='pcOnly' src="/img/hojyokin2024/image_block01_01.png" alt="子育てエコホーム支援事業" />
            <img className='spOnly' src="/img/hojyokin2024/image_block01_01sp.png" alt="子育てエコホーム支援事業" />
            <div className="contents">

              <img className='number' src="/img/hojyokin2024/image_block01_02.svg" alt="子育てエコホーム支援事業" />
              <div className="wrapper">
                <h2>
                子育てエコホーム<br className="spOnly" />支援事業
                <span>
                ※本事業は予算がなくなり次第<br className="spOnly" />終了となります
                </span>
                </h2>
                <div className="flex01">
                  <img className='flex01_image' src="/img/hojyokin2024/image_block01_03.svg" alt="補助額最大100万円" />
                  <div className="flex01_box01">
                    <p>
                    子育てエコホーム支援事業は、エネルギー価格などの物価高騰の影響を受けやすい子育て世帯・若者夫婦世帯による高い省エネ性能を有する新築住宅の取得や、住宅の省エネ改修等に対して支援することにより、子育て世帯・若者夫婦世帯等による省エネ投資の下支えを行い、2050年のカーボンニュートラルの実現を図る事業です。
                    </p>
                    <img className='pcOnly' src="/img/hojyokin2024/image_block01_04.svg" alt="補助対象" />
                    <img className='spOnly' src="/img/hojyokin2024/image_block01_04sp.svg" alt="補助対象" />
                  </div>
                </div>
                <div className="tabs">
                  <input id="tab01" type="radio" name="tab-item" defaultChecked />
                  <label className="tab-item" htmlFor="tab01">注文住宅の新築、<br className="spOnly" />新築分譲住宅の購入</label>
                  <input id="tab02" type="radio" name="tab-item" />
                  <label className="tab-item" htmlFor="tab02">リフォーム</label>
                  <div className="tab-content" id="tab01-content">
                    <div className="tab-content__description">
                      <h2>
                      注文住宅の新築、新築分譲住宅の購入
                      </h2>
                      <img className='pcOnly' src="/img/hojyokin2024/image_block01_05.svg" alt="" />
                      <img className='spOnly' src="/img/hojyokin2024/image_block01_05sp.svg" alt="" />
                    </div>
                  </div>
                  <div className="tab-content" id="tab02-content">
                    <div className="tab_content__description">
                      <h2>
                      リフォーム
                      </h2>
                      <img className='pcOnly' src="/img/hojyokin2024/image_block01_09.svg" alt="" />
                      <img className='spOnly' src="/img/hojyokin2024/image_block01_09sp.svg" alt="" />
                    </div>
                  </div>
                </div>
                <div className="period">
                  <div className="period_box">
                    <img className='period01 pcOnly' src="img/hojyokin2024/image_block01_07.svg" alt="" />

                    <div className="spOnly">
                    <img className='period01' src="img/hojyokin2024/image_block01_07sp.svg" alt="" />
                    </div>
                    <a target='_blank' href='https://kosodate-ecohome.mlit.go.jp/graph/' className="period02">
                    予算に対する補助金申請額の割合
                    </a>
                  </div>
                  <div className="period_box">
                    <img className='pcOnly' src="img/hojyokin2024/image_block01_08.svg" alt="" />
                    <img className='spOnly' src="img/hojyokin2024/image_block01_08sp.svg" alt="" />
                  </div>
                </div>
                <div className="eco_link">
                <a target='_blank' href="https://kosodate-ecohome.mlit.go.jp/">子育てエコホーム支援事業</a>
                </div>
                <a href="https://betsudai.co.jp/#service" className="betsudai_link">
                ベツダイのサービス一覧
                </a>
              </div>
            </div>
            
          </div>
          <div className="block block02" id='block02'>
            <img src="/img/hojyokin2024/image_block02_01.png" alt="子育てエコホーム支援事業" />
            <div className="contents">

              <img className='number' src="/img/hojyokin2024/image_block02_02.svg" alt="子育てエコホーム支援事業" />
              <div className="wrapper">
                <h2>
                  住宅ローン減税
                  <p>
                    住宅ローンを借り入れて住宅の<br className="spOnly" />新築・取得又は増改築等をした場合、<br />
                    年末のローン残高の0.7％を<br className="spOnly" />所得税（一部、翌年の住民税）から<br className="spOnly" />最大13年間控除する制度です。
                  </p>
                </h2>
                <h3>
                令和6〜7年入居
                </h3>
                <img className='pcOnly' src="img/hojyokin2024/image_block02_03.svg" alt="" />
                <div className="spOnly spTable">
                  <div className="spTableWrapper">
                    <img className='spOnly' src="img/hojyokin2024/image_block02_03sp01.svg" alt="" />
                  </div>
                  </div>
                <div className="spOnly spTable noafter">
                  <div className="spTable2">
                    <div className="spTableWrapper">
                      <img className='spOnly' src="img/hojyokin2024/image_block02_03sp04.svg" alt="" />
                    </div>
                  </div>
                    <img className='spOnly' src="img/hojyokin2024/image_block02_03sp05.svg" alt="" />
                </div>
                <a href="https://betsudai.co.jp/#service" className="betsudai_link">
                ベツダイのサービス一覧
                </a>
              </div>
            </div>
          </div>
          <div className="block block03" id='block03'>
            <img src="/img/hojyokin2024/image_block03_01.png" alt="子育てエコホーム支援事業" />
            <div className="contents">

              <img className='number' src="/img/hojyokin2024/image_block03_02.svg" alt="子育てエコホーム支援事業" />
              <div className="wrapper">
                <h2>
                贈与税の非課税枠
                <p>
                父母や祖父母などの直系尊属から<br className="spOnly" />住宅の新築・取得・増改築のための<br className="spOnly" />資金の贈与を受けた場合、<br />
                一定の金額まで贈与税を<br className="spOnly" />非課税とする制度です。<br />
                （適用期限：令和８年12月31日）
                </p>
                </h2>
                <div className="block03_box01">
                  <div>
                    <h2>
                      要件
                    </h2>
                    <p>
                      令和6年1月1日から<br />
                      令和8年12月31日までに贈与
                    </p>
                    <p>
                      床面積550m2以上<br />
                      かつ所得金額2,000万円以下、<br />
                      または床面積40m2以上50m2未満<br />
                      かつ所得金額1,000万円以下の場合
                    </p>
                  </div>
                  <div className="spTable">
                  <div className="spTableWrapper">
                  <img className='pcOnly' src="img/hojyokin2024/image_block03_03.svg" alt="" />
            <img className='spOnly' src="/img/hojyokin2024/image_block03_01sp.svg" alt="子育てエコホーム支援事業" />
                  </div>
                  </div>
                </div>
                <div className="flex01">
                  <div className="contents">

                  <img className='spOnly' src="img/hojyokin2024/image_block03_04.svg" alt="" />
                    <h3>
                    質の高い住宅の要件
                    </h3>
                    <p>
                    以下のいずれかに該当すること。<br />
                    ※増改築の場合においては、増改築後の住宅が以下のいずれかに該当すること。
                    </p>
                    <div className="flex02">
                      <div className="title">
                      新築住宅
                      </div>
                      <ul>
                        <li>
                          断熱等性能等級5以上 (結露の発生を防止する対策に関する基準を除く)<br />
                          かつ一次エネルギー 消費量等級6以上<br />
                          ※令和5年末までに建築確認を受けた住宅又は令和6年6月30日までに建築された住宅は、断熱等性能等級4以上又は一次エネルギー消費量等級4以上
                        </li>
                        <li>
                          耐震等級(構造躯体の倒壊等防止)2以上又は免震建築物
                        </li>
                        <li>
                          高齢者等配慮対策等級 (専用部分) 3以上
                        </li>
                      </ul>
                    </div>
                    <div className="flex02">
                      <div className="title">
                      既存住宅<br className="pcOnly" />・増改築
                      </div>
                      <ul>
                        <li>
                        断熱等性能等級4以上又は一次エネルギー消費量等級4以上
                        </li>
                        <li>
                        耐震等級(構造躯体の倒壊等防止) 2以上又は免震建築物
                        </li>
                        <li>
                        高齢者等配慮対策等級 (専用部分)3以上
                        </li>
                      </ul>
                      <p className="spOnly">
                      ※本ページの内容は国土交通省ホームページ等に基づいています
                      </p>
                    </div>
                  </div>
                  <img className='pcOnly' src="img/hojyokin2024/image_block03_04.svg" alt="" />
                </div>
              </div>
                <a href="https://betsudai.co.jp/#service" className="betsudai_link">
                ベツダイのサービス一覧
                </a>

            </div>
          </div>
          <div className="block block04" id='block04'>
            <img src="/img/hojyokin2024/image_block04_01.png" alt="子育てエコホーム支援事業" />
            <div className="contents">

              <img className='number' src="/img/hojyokin2024/image_block04_02.svg" alt="子育てエコホーム支援事業" />
              <div className="wrapper">
                <h2>
                  【フラット35】
                  <p>
                    民間金融機関と住宅金融支援機構が<br className="spOnly" />提携して提供する最長35年の<br className="spOnly" />全期間固定金利の住宅ローンです。<br />
                    【フラット３５】Sや<br className="spOnly" />【フラット３５】子育てプラスなどを<br className="spOnly" />利用することで金利が一定期間<br className="spOnly" />引き下げられます！
                  </p>
                </h2>
                <div className="flex01" style={{ alignItems: 'center' }}>
                  <div className="box01">
                    <img src="img/hojyokin2024/image_block04_03.svg" alt="" />
                    <p>
                    住宅の性能や長く住んでいくための配慮の状況等に応じて金利引下げメニューを組み合わせることが可能です。<br />
                    組み合わせた結果、【フラット３５】の金利引下げの期間及び金利引下げ幅が異なります。
                    </p>
                  </div>
                  <div className="image01">
                    <img src="img/hojyokin2024/image_block04_04.svg" alt="" />
                  </div>

                </div>
                <h3>
                【フラット３５】Sとは
                </h3>
                <div className="flex01">
                  <div className="box01">
                    <p>
                    【フラット３５】Ｓとは、【フラット３５】をお申込みのお客さまが、省エネルギー性・耐震性などを備えた質の高い住宅を取得する場合に、【フラット３５】の借入金利を一定期間引き下げる制度です。
                    </p>
                  </div>
                  <div className="image01">
                    <img src="img/hojyokin2024/image_block04_05.svg" alt="" />
                  </div>
                </div>
                <h3>
                【フラット３５】<br className="spOnly" />子育てプラスとは
                </h3>
                <div className="flex01">
                  <div className="box01">
                    <p>
                    【フラット35】子育てプラスとは、子育て世帯または若年夫婦世帯に対して全国一律でこどもの人数等に応じて一定期間借入金利を引き下げる制度です。（2025年3月31日までの申込受付分に適用）
                    </p>
                    <img className='pcOnly' src="img/hojyokin2024/image_block04_06.svg" alt="" />
                    <img className='spOnly' src="img/hojyokin2024/image_block04_06sp.svg" alt="" />
                  </div>
                  <div className="image01">
                    <img src="img/hojyokin2024/image_block04_07.svg" alt="" />
                  </div>

                </div>

                <div className="image_block04_08">
                  <img className='pcOnly' src="img/hojyokin2024/image_block04_08.svg" alt="" />
                  <div className="spTable spOnly">
                    <h4>
                    【試算例】借入額3,000万円（融資率９割以下）、借入期間35年、元利均等返済、<br className="spOnly" />ボーナス返済なし、借入金利年1.80％の場合
                    </h4>
                  <div className="spTableWrapper">
                  <img className='spOnly' src="/img/hojyokin2024/image_block04_09sp.svg" alt="子育てエコホーム支援事業" />
                  </div>
                  </div>
                </div>

                <img className='spOnly' src="/img/hojyokin2024/image_block04_10sp.svg" alt="子育てエコホーム支援事業" />



              </div>

              <div className="eco_link">
                <a target='_blank' href="https://www.flat35.com/">【フラット35】公式サイト</a>
                </div>
                <a href="https://betsudai.co.jp/#service" className="betsudai_link">
                ベツダイのサービス一覧
                </a>

            </div>
          </div>
        </div>
        <div className="c-page-sub__footer">
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default OitanaviPage
